export const dialog = {
  paperWidthSm: {
    maxWidth: '668px',
  },
};

export default dialog;
